import * as React from 'react';
import {watchSize} from '../util/watchSize';

interface ResponsiveBarProps extends React.Props<ResponsiveBar> {
    children?: React.ReactElement<any>[];
}

interface ResponsiveBarState {
    collapsedStatus: boolean[];
    openChild: number;
}

export default class ResponsiveBar extends React.Component<ResponsiveBarProps, ResponsiveBarState> {
    private bar: HTMLElement;
    private allCollapsed = false;
    private unwatchSize: () => void;

    constructor(props: ResponsiveBarProps) {
        super(props);
        this.state = {
            collapsedStatus: [],
            openChild: null
        };
    }

    componentDidMount() {
        if (this.isOverflow()) {
            this.collapseLastGroup();
        }
        this.unwatchSize = watchSize(this.bar, this.handleResize);
    }

    componentWillUnmount() {
        this.unwatchSize();
    }

    componentDidUpdate() {
        if (this.isOverflow() && !this.allCollapsed) {
            this.collapseLastGroup();
        }
    }

    render() {
        const style = this.getStyle();
        return (
            <div ref={(element: HTMLElement) => {this.bar = element;}} style={style.root}>
            {
                this.props.children
                .filter((value) => value !== null)
                .map((child: React.ReactElement<any>, i: number) => {
                    const props = child.props.collapsible ? {
                        key: i,
                        collapsed: this.state.collapsedStatus[i],
                        open: this.state.openChild === i,
                        onOpen: () => { this.setState({openChild: i} as ResponsiveBarState);},
                        onClose: () => { this.setState({openChild: null} as ResponsiveBarState);}
                    }
                    : {key: i};
                    return React.cloneElement(child, props);
                })
            }
            </div>
        );
    }

    private handleResize = (width: number, height: number) => {
        this.allCollapsed = false;
        this.setState({collapsedStatus: []} as ResponsiveBarState);
    };

    private isOverflow() {
        return this.bar.scrollWidth > this.bar.clientWidth;
    }

    private collapseLastGroup() {
        const children = this.props.children;

        let found = false;

        const collapsedStatus: boolean[] = [];

        for (let i = children.length - 1; i >= 0; i--) {
            const child = children[i];
            const collapsible = child.props.children && child.props.children.length > 1 && !!child.props.Icon;

            if (!this.state.collapsedStatus[i] && !found && collapsible) {
                collapsedStatus[i] = true;
                found = true;
            } else {
                if (collapsible) {
                    collapsedStatus[i] = this.state.collapsedStatus[i];
                } else {
                    collapsedStatus[i] = null;
                }
            }
        }

        this.allCollapsed = !found;

        this.setState({collapsedStatus} as ResponsiveBarState);
    }

    private getStyle() {
        return {
            root: {
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: "100%"
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/ResponsiveBar.tsx
 **/